import selfieOverlay from 'assets/camera_placeholder/selfie-overlay.png';
import selfieOutlineKTP from 'assets/camera_placeholder/selfie-outline-ktp.png';
import selfieOutlineNPWP from 'assets/camera_placeholder/selfie-outline-npwp.png';
import selfieOutlineSIM from 'assets/camera_placeholder/selfie-outline-sim.png';

import { SelfieFrameProps } from './types';
import { selfieFrameCx } from './styles';
import { useMemo } from 'react';

const SelfieFrame = (props: SelfieFrameProps) => {
  const { docType } = props;

  const selfieOutline = useMemo(() => {
    switch (docType) {
      case 'drivers_license':
        return selfieOutlineSIM;
      case 'npwp':
        return selfieOutlineNPWP;
      case 'ktp':
      default:
        return selfieOutlineKTP;
    }
  }, [docType]);

  return (
    <svg
      width='100vw'
      height='100vh'
      className={selfieFrameCx}
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid slice'
    >
      <defs>
        <mask id='mask' x='0' y='0'>
          <rect fill='white' x='0' y='0' width='100vw' height='100vh' />
          <image
            className='selfie-overlay'
            href={selfieOverlay}
            width='90%'
            x='5%'
            y='10%'
            height='calc(90% - 212px)'
          />
        </mask>
      </defs>
      <rect
        fill='#181818B2'
        width='100vw'
        height='100vh'
        x='0'
        y='0'
        mask='url(#mask)'
        fillOpacity='100%'
      />
      <image
        className='selfie-outline'
        x='5%'
        y='10%'
        href={selfieOutline}
        width='90%'
        height='calc(90% - 212px)'
      />
    </svg>
  );
};

export default SelfieFrame;
